// AJAX wrapper na formularz Add-to-Cart na single product (PDP).
// Cel: po dodaniu nie odświeża strony, tylko otwiera cart drawer (window.kbCartDrawer.open).
// Obsługuje simple ORAZ variable (wariant = wybrany rozmiar); grouped → normalny submit.

function wcAjaxUrl(action) {
  const base = (window.KB && window.KB.shopUrl) ? window.KB.shopUrl : (window.location.origin + '/');
  const sep = base.indexOf('?') === -1 ? '?' : '&';
  return base + sep + 'wc-ajax=' + encodeURIComponent(action);
}

function applyFragments(fragments) {
  Object.keys(fragments || {}).forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      const tpl = document.createElement('template');
      tpl.innerHTML = fragments[selector];
      const next = tpl.content.firstElementChild;
      if (next && el.parentNode) el.parentNode.replaceChild(next, el);
    });
  });
}

function initPdpAjaxAtc() {
  const form = document.querySelector('form.cart');
  if (!form) return;

  // Grouped ma wiele pól ilości na raz — zostaje przy zwykłym submicie.
  if (form.classList.contains('grouped_form')) return;
  const jestWariantowy = form.classList.contains('variations_form');

  const submitBtn = form.querySelector('.single_add_to_cart_button')
    || form.querySelector('button[type="submit"]');

  form.addEventListener('submit', (e) => {
    // Wartość product_id leci albo z input[name="add-to-cart"] (formularz simple) albo z value submit-buttonu.
    const productIdField = form.querySelector('input[name="add-to-cart"]');
    const submitter = e.submitter || submitBtn;
    const productId = (productIdField && productIdField.value) || (submitter && submitter.value);
    if (!productId) return;

    // Przy wariantowym WooCommerce oczekuje w `product_id` id WARIANTU — parenta i atrybuty
    // dolicza sobie sam (WC_AJAX::add_to_cart). Bez wybranego wariantu nie ma czego dodać,
    // więc oddajemy sterowanie zwykłemu submitowi, żeby serwer pokazał komunikat walidacji.
    const wariantId = jestWariantowy
      ? (form.querySelector('[data-variation-id]') || {}).value
      : '';
    if (jestWariantowy && !wariantId) return;

    // Mystery box bez rozmiaru: exclude-clubs.js zatrzymuje wysyłkę i otwiera wybór rozmiaru.
    // Bez tego warunku żądanie i tak leciało, serwer odmawiał, a strona się przeładowywała.
    const wymaganyRozmiar = form.querySelector('[data-msize-input]');
    if (wymaganyRozmiar && !wymaganyRozmiar.value) return;

    e.preventDefault();

    // Express (Apple Pay / Google Pay) = ścieżka Kup Teraz + flaga portfela; serwer
    // ustawia preselekcję bramki paynow na checkoucie (inc/woocommerce-hooks.php).
    const expressWallet = (submitter && submitter.getAttribute && submitter.getAttribute('data-express-pay')) || '';
    const isBuyNow = !!expressWallet || (submitter && submitter.hasAttribute && submitter.hasAttribute('data-buy-now'));
    const qtyField = form.querySelector('input[name="quantity"]');

    const clickedBtn = submitter || submitBtn;
    if (clickedBtn) {
      clickedBtn.disabled = true;
      if (!expressWallet) { // przyciski portfeli mają w środku SVG logo — nie nadpisujemy
        clickedBtn.dataset.kbOrig = clickedBtn.textContent;
        clickedBtn.textContent = isBuyNow ? 'Przekierowuję…' : 'Dodaję…';
      }
    }

    // Serialize całego formularza (mystery box fields, size, variants, etc.)
    // używaj FormData dla proper encoding z attachment support (jeśli w przyszłości)
    const params = new URLSearchParams();
    params.append('product_id', String(jestWariantowy ? wariantId : productId));
    params.append('quantity', qtyField ? String(qtyField.value || 1) : '1');

    // Dodaj mystery box fields jeśli istnieją (dla kompatybilności z inc/mystery-box.php)
    const mysterySize = form.querySelector('input[name="kb_mystery_size"]');
    const mysteryExcludes = form.querySelector('input[name="kb_mystery_excludes"]');
    const mysteryBirthday = form.querySelector('input[name="kb_mystery_birthday"]');
    const mysteryPack = form.querySelector('input[name="kb_mystery_pack"]:checked');

    if (mysterySize && mysterySize.value) params.append('kb_mystery_size', mysterySize.value);
    if (mysteryExcludes && mysteryExcludes.value) params.append('kb_mystery_excludes', mysteryExcludes.value);
    if (mysteryBirthday && mysteryBirthday.checked) params.append('kb_mystery_birthday', '1');
    if (mysteryPack) params.append('kb_mystery_pack', mysteryPack.value || '1');

    // Mystery box z kilkoma rozmiarami: każda grupa [rozmiar, ile] to osobne dodanie (osobna
    // pozycja koszyka). Ostatnia grupa idzie dotychczasową drogą, wcześniejsze po cichu przed nią.
    const msize = form.querySelector('[data-msize]');
    const grupy = JSON.parse((msize && msize.dataset.msizeGroups) || '[]');
    const ostatnia = grupy.length ? grupy[grupy.length - 1] : null;

    // Jedno dodanie przez wc-ajax, z limitem 15 s. Odmowa serwera = wyjątek, jak błąd sieci.
    const wyslij = (grupa) => {
      const p = new URLSearchParams(params);
      if (grupa) {
        p.set('kb_mystery_size', grupa[0]);
        p.set('quantity', String(grupa[1]));
      }
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 15000);
      return fetch(wcAjaxUrl('add_to_cart'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: p.toString(),
        signal: controller.signal,
      })
        .then((r) => r.json())
        .then((json) => {
          if (json && json.error) throw new Error('odmowa');
          return json;
        })
        .finally(() => clearTimeout(timeoutId));
    };
    const wczesniejsze = grupy.slice(0, -1).reduce((kolejka, g) => kolejka.then(() => wyslij(g)), Promise.resolve());

    // Coś nie weszło. Przy jednej grupie zwykły submit powtarza próbę i serwer pokazuje powód.
    // Przy kilku część boxów już jest w koszyku — powtórka dodałaby je drugi raz, więc tylko
    // przeładowanie: karta pokaże komunikat serwera, a koszyk to, co się udało dodać.
    const awaria = () => {
      if (grupy.length > 1) window.location.reload();
      else form.submit();
    };

    // ── KUP TERAZ — pomijamy AJAX i submitujemy serwerowo z flagą `kb_buy_now`.
    // Filter `woocommerce_add_to_cart_redirect` w inc/woocommerce-hooks.php podmienia
    // docelowy URL na checkout. To jest bulletproof — działa nawet jak JS-AJAX fail.
    //
    // KRYTYCZNE: `HTMLFormElement.prototype.submit()` NIE serializuje wartości submit-buttonu,
    // więc trzeba ręcznie wstawić hidden `add-to-cart=<id>` żeby WC odpalił add_to_cart_handler.
    if (isBuyNow) {
      const ensureHidden = (name, value) => {
        let h = form.querySelector(`input[type="hidden"][name="${name}"]`);
        if (!h) {
          h = document.createElement('input');
          h.type = 'hidden';
          h.name = name;
          form.appendChild(h);
        }
        h.value = String(value);
      };
      ensureHidden('add-to-cart', productId);
      ensureHidden('quantity', ostatnia ? ostatnia[1] : (qtyField ? (qtyField.value || 1) : 1));
      ensureHidden('kb_buy_now', '1');
      if (expressWallet) ensureHidden('kb_express_pay', expressWallet);
      wczesniejsze.then(() => {
        // submit() nie wywołuje zdarzenia `submit`, więc ekran ładowania włączamy sami.
        document.querySelector('[data-kb-loader]')?.classList.add('is-active');
        HTMLFormElement.prototype.submit.call(form);
      }).catch(awaria);
      return;
    }

    wczesniejsze
      .then(() => wyslij(ostatnia))
      .then((json) => {
        if (json && json.fragments) {
          applyFragments(json.fragments);
          if (window.jQuery) {
            window.jQuery(document.body).trigger('added_to_cart', [json.fragments, json.cart_hash]);
          } else {
            document.body.dispatchEvent(new CustomEvent('added_to_cart', { detail: { fragments: json.fragments } }));
          }
        }
        if (window.kbCartDrawer && typeof window.kbCartDrawer.open === 'function') {
          setTimeout(() => window.kbCartDrawer.open(), 180);
        }
      })
      .catch(awaria)
      .finally(() => {
        // Przycisk wraca do normalnego stanu także po udanym dodaniu — inaczej zostawał
        // zablokowany na „Dodaję…" i kolejny box (np. w innym rozmiarze) wymagał odświeżenia strony.
        if (clickedBtn) {
          clickedBtn.disabled = false;
          if (clickedBtn.dataset.kbOrig) clickedBtn.textContent = clickedBtn.dataset.kbOrig;
        }
      });
  });
}

// Pokaż WŁAŚCIWY przycisk express pay dla urządzenia: Apple Pay tylko tam, gdzie
// realnie zadziała (wytyczna Apple), Google Pay wszędzie indziej. Oba prowadzą
// i tak przez stronę paynow, więc heurystyka jest bezpieczna — w najgorszym razie
// klient wybierze na paywallu inną metodę.
function initExpressPayButtons() {
  document.querySelectorAll('[data-express-pay-wrap]').forEach((wrap) => {
    const wallet = window.ApplePaySession ? 'apple' : 'google';
    const btn = wrap.querySelector('[data-express-pay="' + wallet + '"]');
    if (!btn) return;
    btn.hidden = false;
    wrap.classList.remove('hidden');
  });
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') { initPdpAjaxAtc(); initExpressPayButtons(); }
  else document.addEventListener('DOMContentLoaded', () => { initPdpAjaxAtc(); initExpressPayButtons(); });
}

export {};
